module.exports = __webpack_public_path__ + "img/bg_04.e67423b2.jpg";